/**
 * CNESLoadingState Component - Loading indicator
 */
import React from 'react';
import { RefreshCw } from 'lucide-react';

export const CNESLoadingState: React.FC = () => {
  return (
    <div className="bg-white rounded-xl shadow-lg p-12 text-center">
      <RefreshCw className="w-12 h-12 mx-auto mb-4 text-green-600 animate-spin" />
      <p className="text-lg text-gray-900 font-semibold">Buscando hospitais...</p>
      <p className="text-sm text-gray-500 mt-2">Aguarde enquanto consultamos a base de dados</p>
    </div>
  );
};
